module.exports = __webpack_public_path__ + "static/media/scratch-off-track-and-trace-one.c99b583c.svg";